/* LES MONTANTS D'UN LOT DE REGLEMENTS.

   Le net etait calcule a deux endroits - la colonne « Net a payer » du tableau, ligne a
   ligne, et le recapitulatif qui precede l'enregistrement du cheque, sur les totaux du
   lot. Meme formule, deux ecritures : c'est le genre de doublon qui finit par deriver, et
   celui-ci porte le chiffre qu'on compare au cheque qu'on tient en main. */
import i18n from '../../i18n';

/** Arrondi a deux decimales, pour que la soustraction ne traine pas de centiemes. */
const arrondi2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

/**
 * Le net a payer : ce que le beneficiaire touche reellement.
 *
 * <p>C'est le montant du cheque. Le tableau donnait le TTC et la retenue, et laissait la
 * soustraction au lecteur.
 */
export function netAPayer(montantTtc, montantTaxe) {
  return arrondi2(arrondi2(montantTtc) - arrondi2(montantTaxe));
}

/**
 * Les lignes du recapitulatif montre avant d'enregistrer le cheque global.
 *
 * <p>POURQUOI UN RECAPITULATIF. L'enregistrement du cheque fait avancer le lot d'une
 * etape du circuit comptable, et le numero saisi est unique : le serveur le refuse s'il
 * existe deja ailleurs. On confirme donc sur ce qui se verifie contre le cheque qu'on
 * tient - son numero, sa banque, et surtout son montant.
 *
 * @param {object} lot     le lot, pour ses totaux
 * @param {object} valeurs les champs saisis, deja valides par le formulaire
 */
export function recapCheque(lot, valeurs) {
  const net = netAPayer(lot?.montantTtcTotal, lot?.montantTaxeTotal);
  return [
    { libelle: i18n.t('reglementsExperts:cheque.recap.lot'), valeur: lot?.numeroLot || '-' },
    { libelle: i18n.t('reglementsExperts:cheque.recap.expert'), valeur: lot?.expertNomComplet || '-' },
    { libelle: i18n.t('reglementsExperts:cheque.recap.reglements'), valeur: String(lot?.nombreReglements ?? 0) },
    { libelle: i18n.t('reglementsExperts:cheque.recap.numeroCheque'), valeur: valeurs?.numeroChequeEmis || '-' },
    // La banque est facultative a la saisie : le dire plutot que de laisser un tiret
    // qu'on pourrait prendre pour une donnee perdue.
    { libelle: i18n.t('reglementsExperts:cheque.recap.banque'), valeur: valeurs?.banqueCheque || i18n.t('reglementsExperts:cheque.recap.banqueNonPrecisee') },
    { libelle: i18n.t('reglementsExperts:cheque.recap.montant'), valeur: net, estMontant: true },
  ];
}
